import { Box, CircularProgress, Typography } from '@mui/material';
import theme from '../theme';

export const LoadingState = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: 'calc(100vh - 200px)',
        color: '#888',
        gap: 1
      }}
    >
      <CircularProgress sx={{ fontSize: 48, opacity: 0.5, color: theme.palette.primary.main }} />
      <Typography variant="body1" sx={{ fontSize: '1.1rem' }}>
        로딩 중
      </Typography>
    </Box>
  );
}; 